/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const RoseLem: any = (props: {}) => {
    return (
        <svg width="104" height="153" viewBox="0 0 104 153" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.3537 48.0134C50.9762 48.0134 73.2264 65.7042 73.2264 96.2822C73.2264 124.622 49.9833 144.552 20.3537 144.552C-10.5539 144.552 -31.0005 124.775 -32.5308 93.3905C-33.8578 66.0863 -17.3219 18.6231 35.8826 0.724152L38.542 5.93758C24.435 15.5371 13.5178 30.6067 12.0694 40.2483C10.7229 49.2155 17.9185 48.0134 20.3537 48.0134Z"
                fill="#FFC9FA"
            />
            <path
                d="M58.6358 73.4552L58.6359 73.4549C60.7146 64.161 66.5206 56.9111 77.0902 55.1393L77.0903 55.1393C85.6286 53.7074 93.0114 56.5625 97.5937 61.7382C102.172 66.9097 104.025 74.4766 101.346 82.6367C100.103 86.3265 98.321 89.8121 96.0563 92.9812L96.0547 92.9834C85.5442 107.775 74.9206 122.488 63.9888 137.627C60.665 142.23 57.3127 146.873 53.9265 151.569L44.0506 147.462C45.3851 140.558 46.6823 133.658 47.9781 126.764C51.333 108.918 54.6784 91.1221 58.6358 73.4552Z"
                stroke="white"
                strokeWidth="2"
            />
        </svg>
    );
};

export default RoseLem;
